import { render } from "./GlobalLoading.vue?vue&type=template&id=2e52a0d0"
import script from "./GlobalLoading.vue?vue&type=script&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&lang=js"

import "./GlobalLoading.vue?vue&type=style&index=0&id=2e52a0d0&lang=css"

import exportComponent from "/app/tmp/10eqs/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__